<template>
  <el-drawer ref="drawer" title="" :visible.sync="homePage" :with-header="false" :show-close="false" :close-on-press-escape="false" :wrapperClosable="false" direction="ttb" size="100%">
    <div id="top">

    <link :href="dynamicCssPath" rel="stylesheet" type="text/css">
		<div middle>

      <el-dialog modal="false" :title="$t('update.localhostTitle')"
      width="50%" 
      destroy-on-close="true"  
      :close-on-click-modal="false" 
      :close-on-press-escape="false"
      :visible.sync="dialogLocalhostVisible">
      <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
      <child-localhostC :key="componentKey" @child-event="dialogLocalhostVisible = false"  ref="childlocalhostref"></child-localhostC>
      </el-dialog>

      <el-dialog :title="$t('update.cloudTitle')"
      width="50%" 
      destroy-on-close="true"  
      :close-on-click-modal="false" 
      :close-on-press-escape="false"
      :visible.sync="dialogCloudVisible">
      <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
      <child-cloudC :key="componentKey"  ref="childcloudc"></child-cloudC>

      </el-dialog>


			<div logo><img :src="getLogoPath()"></div>
      <el-menu :default-active="activeMenuItem" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1">{{$t("homePage.home")}}</el-menu-item>
        <el-menu-item index="2" @click="shop">{{$t("footer.shop")}}</el-menu-item>
        <el-menu-item index="3" @click="contact">{{$t("footer.contact")}}</el-menu-item>
        <!-- <el-menu-item index="4"><el-link underline="false" href="https://hexgears.longeplay.cn/C2.zip">C2固件离线更新包</el-link></el-menu-item> -->
      </el-menu>
			<div option>
        <el-dropdown @command="selectLanguage">
          <span class="el-dropdown-link" style=" font-weight: bold;font-size: small;color: #9c9c9c;">
            <i class="el-icon-location-outline el-icon--right"></i> {{selectedLanguage}}
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :class="item.value"  style="height: 40px; line-height: 40px;" :command="item.value + '|' + item.label" v-for="(item, index) in languages">{{item.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

			</div>


      <div main class="homeMain">
        <h2>{{$t("homePage.welcome")}} {{brand}}</h2>
        <p>{{$t("homePage.desc")}}</p>

        <ul>
          <li connect v-on:click="connectDrive">
            <div>
              <h1>{{$t("homePage.connecting")}}</h1>
              <i>{{$t("homePage.clickConnect")}}</i>
            </div>
          </li>
          <li play v-on:click="video">
            <div>
              <h1>{{$t("homePage.video")}}</h1>
              <i>{{$t("homePage.videoDesc")}}</i>
            </div>
          </li>

          <el-popover placement="bottom" width="400"  v-model="isshow" trigger="click">
            <ul class="parductList">
              <li @click="enter(item.FirmwareVer)" v-for="(item, index) in productList" :key="item">
                <span>
                  <img :src="getProductPath(item.model)" width="100"/>
                </span>
                
                <div>
                  <h1>{{item.name}}</h1>
                  <i v-if="curHIDDeviceObj !== null && curHIDDeviceObj.FirmwareVer == item.FirmwareVer">{{$t("homePage.ready")}}</i>
                </div>
              </li>
            </ul>

            <li zc slot="reference">
              <div>
                <h1>{{$t("homePage.supported")}}</h1>
                <i>{{$t("homePage.view")}}</i>
              </div>
            </li>
          </el-popover>
        </ul>

      </div>

      <el-carousel :interval="4000" height="400px">
        <el-carousel-item v-for="item in productList" :key="item">
          <img :src="getProductPath(item.model)">
        </el-carousel-item>
      </el-carousel>

		</div>

	  </div>
  </el-drawer>
</template>

<script>
import axios from 'axios';
// 导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../../../asserts/js/hid_device.js';

import localhostC from '../../../../components/update/localhost.vue'
import cloudC from '../../../../components/update/cloud.vue'
export default {
  name: 'drive',
  components: 
  {
    'child-localhostC':localhostC,
    'child-cloudC':cloudC,
  },
  data() {

    return {
      ThemeConf:null,
      activeMenuItem:"1",
      productList:[],
      curHIDDeviceObj:null,
      activeMenuItem:"1",
      dialogLocalhostVisible:false,
      dialogCloudVisible:false,
      componentKey:0,
      selectedLanguage: '中文',
      selectedLanguageCode: 'zh',
      brand:"",
      homePage:true,
      isshow:false,
      languages: [
        { label: '中文', value: 'zh'},
        { label: 'English', value: 'en'},
        { label: '日本語', value: 'jp' },
        { label: 'Россия', value: 'ru' },

        // { label: 'Español', value: 'es' },
        // { label: 'Français', value: 'fr' },
        // { label: 'Deutsch', value: 'de' },
        // { label: 'Italia', value: 'it' },
        // { label: 'العرب', value: 'ar' },
        // { label: 'Nederland', value: 'ne' },
        // { label: '한국', value: 'ko' },
        // { label: 'Portugal', value: 'po' },
        // { label: 'ประเทศไทย', value: 'th' },
        // { label: 'Việt Nam', value: 'vi' },
        // { label: 'polinesia', value: 'po' },
        
        // 添加更多语言
      ]
    }
  },
  mounted()
  {
      let context = this;
      let setLanguageText = function(languageCode)
      {
          for(let i in context.languages)
          {
             if(context.languages[i].value == languageCode)
             {
                context.selectedLanguage = context.languages[i].label;
                break;
             }
          }
      }

      let languageCode =  localStorage.getItem('language') || 'zh';
          setLanguageText(languageCode);
  },
  updated: function () 
  {

  },
  methods:
  { 
      video()
      {
        this.$message({message:this.$i18n.t("msg.LookForward"),type: 'warning',center: true,offset:500});
        return;
      },
      enter(FirmwareVer)
      {   
        if(this.curHIDDeviceObj == null  || this.curHIDDeviceObj.FirmwareVer != FirmwareVer)
        {
          this.$message({message:this.$i18n.t("msg.loadingConnectWarn"),type: 'warning',center: true,offset:500});
          return;
        }

        this.isshow = false; 
        this.homePage= false;
        this.$emit('child-event');

      },
      shop()
      {
        if(this.ThemeConf == null && this.ThemeConf.ShopUrl == "")
        {
          this.$message({message:'请配置商店链接',type: 'warning',center: true,offset:500});
          return;
        }

        window.open(this.ThemeConf.ShopUrl, '_blank');
        
      },
      contact()
      {
        if(this.ThemeConf == null && this.ThemeConf.HomeUrl == "")
        {
          this.$message({message:'请配置品牌官网链接',type: 'warning',center: true,offset:500});
          return;
        }

        window.open(this.ThemeConf.HomeUrl, '_blank');
      },
      showList()
      {
        this.isshow =true;
      },
      init()
      {
          this.productList = this.ThemeConf.DeviceList;
      },
      //获取主题LOGO
      getLogoPath()
      {
        let imgUrl = require("../../../" + process.env.VUE_APP_THEMENAME + "/asserts/image/logo.png");
        return imgUrl;
      },
      //获取产品图片
      getProductPath(name)
      {
        let imgUrl = require("../../../drives/" + name + "/asserts/image/product.png");
        return imgUrl;
      },
      //更新连接设备状态
      updateList()
      {
          this.productList = this.ThemeConf.DeviceList;
          let moveItemInArray = function(array, fromIndex, toIndex) 
          {
                const element = array.splice(fromIndex, 1)[0];
                array.splice(toIndex, 0, element);
          }
          for(let i=0;i<this.productList.length;i++)
          {
            if(this.productList[i].FirmwareVer == this.curHIDDeviceObj.FirmwareVer)
            {
                moveItemInArray(this.productList,i,0);

                this.isshow = this.homePage;
            }
          }
          
          this.languages = this.ThemeConf.languages;
          this.brand = this.ThemeConf.Brand;


          if(this.curHIDDeviceObj.RunMode>0)
          {
              this.cloudUpdate();
          }

      },
      //点击连接HID设备
      async connectDrive()
      {
        await navigator.hid.requestDevice({filters:this.ThemeConf.verifyDevices})
        .then(async devices => 
        {
              // 连接到设备
              const device = devices[0];
              await device.open();
        
              if(device.opened)
              {
                // this.isshow =true;
                setTimeout(()=>{window.location.reload();},1000);
              }
              
        }).catch(error => 
        {
            console.error('连接错误', error);
        });
        
      },
      //获取设备图标
      getProductLogoPath(model)
      {
        let imgUrl = require("../../../drives/" + model + "/asserts/image/logo.png");   
        return imgUrl;
      },
      download(item)
      {
          this.$message({message:'暂未开放.....敬请期待!',type: 'warning',center: true,offset:100,duration:1000});
      },
      selectLanguage(item)
      {
          let items = item.split("|");
          this.selectedLanguage = items[1];
          this.selectedLanguageCode = items[0];
          this.$i18n.locale = items[0];

          localStorage.setItem('language', this.$i18n.locale);
          window.location.reload();
      },
      cloudUpdate()
      {
        this.dialogCloudVisible = true;
        this.componentKey += 1;

        setTimeout(()=>
        {
          const ChildCloudC = this.$refs.childcloudc;

                ChildCloudC.ThemeConf = this.ThemeConf;
                ChildCloudC.init(this.curHIDDeviceObj);
        },100);

      },
  },
  computed: 
  {
      dynamicCssPath: function() 
      {
        return require("../asserts/css/homePage.css"); 
      }
  }
}

</script>